import { generateUtilityClasses } from '@mui/material';

export const compactPaginationClasses = generateUtilityClasses('CompactPagination', [
  'root',
  'actions',
]);
